import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ExternalLink, ShoppingBag } from 'lucide-react';

const LIFEWAVE_SHOP_URL = 'https://lifewave.com/ioanaalexandra/store/products';

const ShopBanner = () => {
  const { language } = useLanguage();

  const translations = {
    en: {
      title: "Ready to Start Your Wellness Journey?",
      subtitle: "Visit my official LifeWave store and discover products that can transform your life",
      button: "Visit My Official Store"
    },
    ro: {
      title: "Ești Pregătit să Începi Călătoria spre Wellness?",
      subtitle: "Vizitează magazinul meu oficial LifeWave și descoperă produsele care îți pot transforma viața",
      button: "Vizitează Magazinul Meu Oficial"
    },
    es: {
      title: "¿Listo para Comenzar tu Viaje de Bienestar?",
      subtitle: "Visita mi tienda oficial de LifeWave y descubre productos que pueden transformar tu vida",
      button: "Visita Mi Tienda Oficial"
    },
    it: {
      title: "Pronto a Iniziare il Tuo Viaggio verso il Benessere?",
      subtitle: "Visita il mio negozio ufficiale LifeWave e scopri i prodotti che possono trasformare la tua vita",
      button: "Visita il Mio Negozio Ufficiale"
    },
    de: {
      title: "Bereit, Deine Wellness-Reise zu Beginnen?",
      subtitle: "Besuche meinen offiziellen LifeWave-Shop und entdecke Produkte, die dein Leben verändern können",
      button: "Besuche Meinen Offiziellen Shop"
    }
  };

  const t = translations[language] || translations['en'];

  return (
    <section className="py-16 bg-gradient-to-r from-sky-600 via-sky-500 to-cyan-500 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-6 backdrop-blur-sm">
          <ShoppingBag className="w-4 h-4" />
          LifeWave Official
        </div>

        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          {t.title}
        </h2>
        
        <p className="text-sky-100 text-lg mb-8 max-w-2xl mx-auto">
          {t.subtitle}
        </p>

        <button
          onClick={() => window.open(LIFEWAVE_SHOP_URL, '_blank')}
          className="inline-flex items-center gap-3 bg-white text-sky-600 hover:bg-sky-50 px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
        >
          <ExternalLink className="w-5 h-5" />
          {t.button}
        </button>
      </div>
    </section>
  );
};

export default ShopBanner;
